export class Naics {
    CODE: number;
    NAICS_DESC: string;
    SDE_MULTIPLE: number;
    SDE_MARGIN: number;
    CAN_VALUE: boolean;
    MIN_COMP: number;
    MAX_COMP: number;
    R_DV: boolean;
    R_PG: boolean;
    R_BE: boolean;
    R_RR: boolean;
    R_LOC: boolean;
    CAN_EV_REVENUE: boolean;

    // Helpers
    isOver: boolean;

    constructor(value: Object = {}) {
        Object.assign(this, value);
    }

    static parse(json: any): Naics {
        if (json) {
            const n = new Naics();

            n.CODE = json.CODE;
            n.NAICS_DESC = json.NAICS_DESC;
            n.SDE_MULTIPLE = json.SDE_MULTIPLE;
            n.SDE_MARGIN = json.SDE_MARGIN;
            n.CAN_VALUE = json.CAN_VALUE;
            n.MIN_COMP = json.MIN_COMP;
            n.MAX_COMP = json.MAX_COMP;
            n.R_DV = json.R_DV;
            n.R_PG = json.R_PG;
            n.R_BE = json.R_BE;
            n.R_RR = json.R_RR;
            n.R_LOC = json.R_LOC;
            n.CAN_EV_REVENUE = json.CAN_EV_REVENUE;

            return n;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<Naics> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(Naics.parse(j));

        return arr;
    }

    get lowerRangeString(): string {
        if (this.SDE_MULTIPLE)
            return (Math.round(this.SDE_MULTIPLE * 0.85 * 4) / 4).toFixed(2);
        return '';
    }

    get upperRangeString(): string {
        if (this.SDE_MULTIPLE)
            return (Math.round(this.SDE_MULTIPLE * 1.15 * 4) / 4).toFixed(2);
        return '';
    }

}
